import * as React from "react"
import {Box, Typography} from "@mui/material";
import {getYear} from "@ui-seeker/utils";

import {AppFooterStyles} from "./styles";
import {footerShowLink, footerShowYear, footerText} from "../../@signals";
import AppLink from "../AppLink";


export default function AppFooter({ sx={} }) {
    return <Box component="footer" sx={{ ...AppFooterStyles, ...sx }}>
		<Typography variant="caption" component="div">
			{ footerShowYear.value && <Box component="span" sx={{ mr: .5 }}>
				{getYear()}
			</Box> }
			{ footerText.value }
			{ footerShowLink.value && <AppLink to="https://www.dataseekers.com/" target={"_blank"} underline="hover" sx={{ ml: .2 }}>
				Data Seekers
			</AppLink> }
		</Typography>
	</Box>
}